import { render } from "./S92825.vue?vue&type=template&id=4ae99008"
const script = {}
script.render = render

export default script